import { useCallback } from 'react';
import type { LegacyPermissionKey } from '../config/legacyPermissions';
import { useLegacyPermissions } from '../lib/useLegacyPermissions';

interface UsePermissionsResult {
  hasPermissions: (required?: LegacyPermissionKey[]) => boolean;
}

export function usePermissions(): UsePermissionsResult {
  const permissions = useLegacyPermissions();

  const hasPermissions = useCallback(
    (required?: LegacyPermissionKey[]) => {
      if (!required || required.length === 0) {
        return true;
      }

      return required.every((permission) => Boolean(permissions[permission]));
    },
    [permissions]
  );

  return { hasPermissions };
}
